import React from 'react';
import i18n from '@fe/i18n/dist/i18n';
import cls from '@utils/css-select';
import Popover from 'components/popover';
import styles from './styles.scss';
import { useSelector } from 'react-redux';
import { ConnectState } from 'states/connect';
import { sendEvent } from '@utils/core/track';
import { history } from '@store/history';
import { APPLY_TUTOR } from 'constants/url';
import { COUNTRY_CONFIG } from "constants/country";
import AcIcon from 'ac-components/ac-icon';
const cx = cls(styles);



/**
 * 国家选择框组件
 */
export default function CountrySelector() {
	const lang = useSelector((state: ConnectState) => state.app.local);
	const idx = COUNTRY_CONFIG.findIndex((v) => v.local === lang);

	// 组件渲染时拿不到idx时，页面会报错，下面判断解决这个问题
	if (idx === -1) {
		return null;
	}
	/**
	 * 语言切换
	 */
	const handleSelect = (idx: number) => {
		const { local, countryCode } = COUNTRY_CONFIG[idx];
		sendEvent({
			eventId: 'en_adPage0802_NationSelect',
			eventParam: {
				nationSelect: local,
			},
		});
		i18n.setLocale(local);
		history.replace(APPLY_TUTOR.replace(':countryCode', countryCode) + window.location.search);
	};
	const CountryList = () => {
		return (
			<div className={cx('clist')}>
				{COUNTRY_CONFIG.map((v, idx) => {
					return (
						<div className={cx('item')} key={v.name} onClick={() => handleSelect(idx)}>
							<img loading="lazy" className={cx('img')} src={v.icon} alt={v.name} />
							<span>{v.name}</span>
						</div>
					);
				})}
			</div>
		);
	};
	return (
		<Popover
			placement="bottom"
			content={<CountryList />}
			autoAdjustOverflow={true}
			adjustDirection="right"
			mouseLeaveDelay={0}
			arrowStyle={{ display: 'none' }}
			clickAutoHidden>
			<div className={cx('country-box')}>
				<img loading="lazy" className={cx('icon')} src={COUNTRY_CONFIG[idx].icon} alt={COUNTRY_CONFIG[idx].name} />
				<AcIcon icon={'icon_dropdown'} className={cx('arr')} />
			</div>
		</Popover>
	);
}
